import {Directive, ElementRef, Input, Renderer, OnChanges, SimpleChanges, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {NgModel} from "@angular/forms";

declare var jQuery:any;



@Directive({
    selector: '.selectpicker, [selectpicker]',
    providers: [NgModel],
})
export class SelectpickerDirective implements AfterViewInit {

    @Input() selectpicker: any = {};

    @Input() ngModel;
    @Output() ngModelChange = new EventEmitter();


    constructor(public el: ElementRef, public renderer: Renderer, private model:NgModel) {
    }

    ngOnInit(){
        this.model.valueChanges.subscribe((value) => {
            jQuery(this.el.nativeElement).selectpicker('refresh');
        });
    }
    
    ngAfterViewInit() {
        jQuery(this.el.nativeElement).selectpicker(this.selectpicker);
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/selectpicker/selectpicker.directive.ts